import React from 'react'
import PurchaseReport from '../Components/Reports/PurchaseReport'

function PurchaseReportPage() {
  return (
    <>
    <PurchaseReport/>
    </>
  )
}

export default PurchaseReportPage